import { FC, useCallback, useEffect, useState } from 'react';
import { useStore } from '@nanostores/react';
import { $auth, $authFlow, $hasAnyAccess, fetchUserData } from '../store/auth';
import { SectionContainerTransparent } from './AuthCommonStyledComponents';
import { Spin } from 'antd';
import { Navigate } from 'react-router-dom';

export const Finish: FC = () => {
  const authFlowStore = useStore($authFlow)
  const hasAnyAccess = useStore($hasAnyAccess)
  const authStore = useStore($auth)
  const [finishType, setFinishType] = useState<'login' | 'signup'>('login')
  const [internalState, setInternalState] = useState<'init' | 'loaded'>('init')
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)

  const loadUser = useCallback(async () => {
    try {
      await fetchUserData()
    } catch (e) {

    }
  }, [])

  useEffect(() => {
    // console.log('authFlowStore', authFlowStore.state)
    if (authFlowStore.state === 'finish' || authFlowStore.state === 'finish-signup') {
      setInternalState('loaded')
      setFinishType(authFlowStore.state === 'finish' ? 'login' : 'signup')
    }
  }, [authFlowStore]);

  useEffect(() => {
    if (internalState === 'loaded') {
      void loadUser()
    }
  }, [internalState]);

  useEffect(() => {
    if (authStore.isLoggedIn) {
      setTimeout(() => {
        setIsLoggedIn(true)
      }, 200)
    }
  }, [authStore]);

  if (internalState === 'init') {
    return null
  }

  return (
    <SectionContainerTransparent title={finishType === 'login' ? "Login Successful" : "Signup Successful"}>
      {!isLoggedIn ?
        (<Spin size={'large'} />)
        : (
          <>
            {!hasAnyAccess && <Navigate to="/subscribe" replace />}
            {hasAnyAccess && <Navigate to={'/'} />}
          </>
        )}
    </SectionContainerTransparent>
  )
}